import React from 'react';

import SvgContainer from '../SvgContainer';

const Lock = () => {
    return (
        <SvgContainer>
            <path d="M12.5 5.33333H11.75V3.80952C11.75 1.70667 10.07 0 8 0C5.93 0 4.25 1.70667 4.25 3.80952V5.33333H3.5C2.675 5.33333 2 6.01905 2 6.85714V14.4762C2 15.3143 2.675 16 3.5 16H12.5C13.325 16 14 15.3143 14 14.4762V6.85714C14 6.01905 13.325 5.33333 12.5 5.33333ZM8 12.1905C7.175 12.1905 6.5 11.5048 6.5 10.6667C6.5 9.82857 7.175 9.14286 8 9.14286C8.825 9.14286 9.5 9.82857 9.5 10.6667C9.5 11.5048 8.825 12.1905 8 12.1905ZM10.325 5.33333H5.675V3.80952C5.675 2.50667 6.7175 1.44762 8 1.44762C9.2825 1.44762 10.325 2.50667 10.325 3.80952V5.33333Z" />
        </SvgContainer>
    );
};

export default Lock;
